// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__iszJk","footer":"Footer_footer__npAs3"};